import { render, staticRenderFns } from "./Tripartite.vue?vue&type=template&id=73ae4d16&scoped=true"
import script from "./Tripartite.vue?vue&type=script&lang=js"
export * from "./Tripartite.vue?vue&type=script&lang=js"
import style0 from "./Tripartite.vue?vue&type=style&index=0&id=73ae4d16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae4d16",
  null
  
)

export default component.exports